/**
 * Images live on a plain CDN with no transforms, so full-size files (1.5 MB+) were
 * being downloaded for slots a few hundred pixels wide. These helpers route them
 * through a resizing image proxy that returns compressed WebP at the needed width.
 */
const PROXY = 'https://wsrv.nl/'

export function optimizedImage(src: string, width: number, quality = 72): string {
  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&output=webp&q=${quality}&af&il`
}

export function optimizedSrcSet(src: string, widths: number[], quality = 72): string {
  return widths.map((width) => `${optimizedImage(src, width, quality)} ${width}w`).join(', ')
}

// The bundle mockup is the LCP element, so the candidate list is tuned to the real
// rendered size instead of over-serving pixels.
export const HERO_WIDTHS = [420, 560, 720, 960]
export const HERO_SIZES = '(max-width: 640px) 92vw, (max-width: 1024px) 70vw, 560px'

export const OFFER_WIDTHS = [320, 420, 560, 720]
export const OFFER_SIZES = '(max-width: 640px) 86vw, 420px'

export const BONUS_WIDTHS = [220, 320, 440]
export const BONUS_SIZES = '(max-width: 640px) 64vw, (max-width: 1024px) 30vw, 220px'
